export default "__VITE_ASSET__BixxSSDB__"